/**
 * Various tools for string manipulation.
 */

/**
 * Removes diacritics from uppercase strings
 * @param uppercaseText
 */
export const removeAccents = (uppercaseText: string): string =>
  uppercaseText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const adUnitToDivId = (adUnit: string, scope?: string, increment?: number): string =>
  `${adUnit.replace(/^.*\//, '').replace(/_/g, '-').toLowerCase()}${scope ? `-${scope}` : ''}${
    increment ? `-${increment}` : ''
  }`; // e.g. sport24.gr/Matchcenter_ros_300x250A --> matchcenter-ros-300x250a-timeline-1

export default {removeAccents, adUnitToDivId};
